/**
 * Страницы ошибок 403 / 404 / 500. Один шаблон, содержимое определяется состоянием маршрута.
 */
const ERROR_PAGES = {
  403: {
    title: 'Доступ запрещен',
    message: 'У вас недостаточно прав для просмотра этого раздела. Обратитесь к администратору, если доступ необходим.',
  },
  404: {
    title: 'Страница не найдена',
    message: 'Запрошенная страница не существует или была перемещена. Проверьте адрес или воспользуйтесь меню.',
  },
  500: {
    title: 'Внутренняя ошибка',
    message: 'При обработке запроса произошла ошибка. Повторите попытку позже; если ошибка повторяется, обратитесь в техническую поддержку.',
  },
};

export class ErrorPageController {
  /*
   * Параметры берутся из $state.params, а не из $transition$: последний доступен
   * только внутри resolve состояния, а компонент создаётся через views.component.
   * Попытка внедрить $transition$ завершалась ошибкой $injector:unpr, контроллер
   * не создавался, и страница показывала неинтерполированный шаблон.
   */
  /* @ngInject */
  constructor($state, $window) {
    this.$state = $state;
    this.$window = $window;
  }

  $onInit() {
    const params = this.$state.params || {};
    this.code = params.code || (this.$state.current.data || {}).code || 500;
    const page = ERROR_PAGES[this.code] || ERROR_PAGES[500];
    this.title = page.title;
    this.message = params.message || page.message;
    this.path = params.path || '';
    this.correlationId = params.correlationId || '';
  }

  back() {
    this.$window.history.back();
  }
}
